/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import {
  Grid,
  FormControl,
  FormControlLabel,
  Button,
  RadioGroup,
  Radio,
  Select,
  MenuItem,
  TextField,
  Box,
  CircularProgress,
} from '@material-ui/core'
import Stack from '@mui/material/Stack'
import '../Elegibilidad/Style/crearFormularioElegibilidad.scss'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Table52 from './Tables/TablesSec5/Table52'
import Table54 from './Tables/TablesSec5/Table54'
import GantChartExtreme from './Tables/TablesSec5/TableGanttDev'
import { useFormElegibilidad } from '../../../context/ElegibilidadContext'
import {
  getCurrency,
  getCurrencyByCountry,
} from '../../../services/Elegibilidad/get'
import { useHistory } from 'react-router-dom'
import { saveElegibilityForm } from '../../../services/Elegibilidad/create'
import Moment from 'moment'
import NumberFormat from 'react-number-format'
import { useEligibility } from '../../../context/EligibilityContext'
import SaveIcon from '@material-ui/icons/Save'
import ExitIcon from '@material-ui/icons/ExitToApp'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import { LoadingButton } from '@mui/lab'

const ElegibilidadSec5 = (props) => {
  const { goToStep } = props
  const history = useHistory()
  const { EligibilityForm, idElegibilityForm, setEligibilityForm } =
    useFormElegibilidad()
  const [currencyType, setCurrencyType] = useState([])
  const [idCurrencyUser, setIdCurrencyUser] = useState('')
  const [currencyCode, setCurrencyCode] = useState('')
  const [annualSalesDollar, setAnnualSalesDollar] = useState('')
  const [currencyBudget, setCurrencyBudget] = useState('')
  const [state, dispatch] = useEligibility()
  const [loadingSave, setLoadingSave] = useState(false)
  const [loading, setLoading] = useState(false)
  const [errorAnalisis, setErrorAnalisis] = useState(false)
  const [errorAlternativas, setErrorAlternativas] = useState(false)
  const [errorObjetivos, setErrorObjetivos] = useState(false)
  const [errorNarrativa, setErrorNarrativa] = useState(false)
  const [errorEstrategia, setErrorEstrategia] = useState(false)

  // NEXT

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 6 })
    goToStep(6)
  }

  const min = EligibilityForm?.ImplementationDateStart
    ? new Date(EligibilityForm?.ImplementationDateStart)
    : new Date(2023, 1, 1)
  const max = EligibilityForm?.ImplementationDateStart
    ? new Date(EligibilityForm?.ImplementationDateEnd)
    : new Date(2200, 1, 1)

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const exit = true
        saveForm(formik.values, true, exit)
      } else if (result.isDenied) {
        history.push('/')
        setEligibilityForm([])
      }
    })
  }

  const EvaluationDataSchema = Yup.object().shape({
    ProblemAnalysis: Yup.string()
      .required('Este campo es obligatorio')
      .max(1500, 'Máximo 1500 caracteres')
      .matches(
        /^[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      ),
    ProposedSolution: Yup.string()
      .required('Este campo es obligatorio')
      .max(1500, 'Máximo 1500 caracteres')
      .matches(
        /^[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      ),
    ObjectivesActivities: Yup.string()
      .required('Este campo es obligatorio')
      .max(1500, 'Máximo 1500 caracteres')
      .matches(
        /^[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      ),
    ProposedStrategy: Yup.string()
      .required('Este campo es obligatorio')
      .max(1500, 'Máximo 1500 caracteres')
      .matches(
        /^[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      ),
    IdAnnualSalesProject: Yup.string()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    AnnualSales: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    WomenNeeds: Yup.string()
      .required('Este campo es obligatorio')
      .max(2000, 'Máximo 2000 caracteres')
      .matches(
        /^[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      ),
    // validTable52: Yup.boolean().oneOf(
    //   [true],
    //   'Tabla debe de tener mínimo 1 registro',
    // ),
    FundsMonth: Yup.date()
      .required('Este campo es obligatorio')
      .min(
        min,
        `La fecha de especificación de fondos no debe ser menor al período estimado de implementación del proyecto.`,
      )
      .max(
        max,
        `La fecha de especificación de fondos no debe ser mayor al período estimado de implementación del proyecto.`,
      ),
    // .when(
    //   new Date(EligibilityForm.ImplementationDateStart),
    //   (ImplementationDateStart, schema) =>
    //     new Date(EligibilityForm.ImplementationDateStart) &&
    //     schema.min(
    //       new Date(EligibilityForm.ImplementationDateStart),
    //       'La fecha de finalizacion no puede ser menor a la fecha de inicio.',
    //     ),
    // ),
    // .min(
    //   new Date(EligibilityForm.ImplementationDateStart),
    //   `La fecha de no debe se menor a la fecha de inicio de implementación del proyecto`,
    // )
    // .max(
    //   new Date(EligibilityForm.ImplementationDateEnd),
    //   `La fecha de no debe se mayor a la fecha final de implementación del proyecto`,
    // ),
    IdCurrencyBudget: Yup.string()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    TotalSubProjectBudgetValidation: Yup.number()
      .max(
        EligibilityForm.TotalSubProjectBudget,
        `El costo total del proyecto no debe ser mayor al monto total del presupuesto total del proyecto `,
      )
      .min(
        EligibilityForm.TotalSubProjectBudget,
        'El costo total del proyecto no debe ser menor al monto total del presupuesto total del proyecto ',
      ),
    // RequiredAmountValidation: Yup.number()
    //   .max(
    //     EligibilityForm.RequiredAmount,
    //     'El total del préstamo no debe ser mayor al monto total del préstamo solicitado',
    //   )
    //   .min(
    //     EligibilityForm.RequiredAmount,
    //     'El total del préstamo no debe ser menor al monto total del préstamo solicitado',
    //   ),

    RequiredAmountValidation: Yup.number()
      // .when(
      //   'IdCurrencyUser',
      //   (IdCurrencyUser, schema) => {
      //     if (Number(IdCurrencyUser) !== 0 && Number(IdCurrencyUser) !== 3) {
      //       return schema.min(
      //         EligibilityForm.RequiredAmountSourceCurrency   === 0
      //           ? 0.01
      //           : EligibilityForm.RequiredAmountSourceCurrency              ,
      //         'El total del préstamo no debe ser menor al monto total del préstamo solicitado',
      //       )
      //     }
      //   },

      .when('IdCurrencyBudget', {
        is: (IdCurrencyBudget) =>
          IdCurrencyBudget !== 3 || IdCurrencyBudget === 3,
        then: Yup.number().test(
          'superior',
          'El total del préstamo debe ser igual al monto total del préstamo solicitado',
          function (f) {
            const ref =
              formik.values.IdCurrencyBudget !== 3
                ? EligibilityForm.RequiredAmountSourceCurrency
                : EligibilityForm.RequiredAmount
            return f === this.resolve(ref)
          },
        ),
      }),
    // .when('IdCurrencyBudget', {
    //   is: (IdCurrencyBudget) => IdCurrencyBudget === 3,
    //   then: Yup.number().test(
    //     'superior',
    //     'El total del préstamo debe ser igual al monto total del préstamo solicitado',
    //     function (f) {
    //       const ref = EligibilityForm.RequiredAmount
    //       return f === this.resolve(ref)
    //     },
    //   ),
    // }),

    validateGant: Yup.boolean().oneOf(
      [true],
      'Por favor, asegúrese de que la ejecución de las actividades, considere el inicio y fin previstos para la implementación del proyecto',
    ),
  })

  const formik = useFormik({
    validateOnChange: false,
    // enableReinitialize: true,
    initialValues: {
      ProblemAnalysis: '',
      ProposedSolution: '',
      ObjectivesActivities: '',
      ProposedStrategy: '',
      IdAnnualSalesProject: null,
      AnnualSales: null,
      WomenNeeds: '',
      IdCurrencyBudget: EligibilityForm.IdCurrencyUser,
      // validTable52: false,
    },
    validationSchema: EvaluationDataSchema,
    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  useEffect(() => {
    formik.setValues({
      ...formik.values,
      IdCurrencyBudget: EligibilityForm.IdCurrencyUser,
      IdCurrencyAnnualSales: EligibilityForm.IdCurrencyUser,
    })
  }, [EligibilityForm.IdCurrencyUser])

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const saveForm = async (values, borrador, exit) => {
    try {
      setLoading(true)
      setLoadingSave(true)

      const object = {
        ...values,
        IdCurrencyBudget:
          values.IdCurrencyBudget === '' ? null : values.IdCurrencyBudget,
        AnnualSales: values.AnnualSales === '' ? null : values.AnnualSales,
        IdAnnualSalesProject:
          values.IdAnnualSalesProject === ''
            ? null
            : values.IdAnnualSalesProject,
        FundsMonth: values.FundsMonth === '' ? null : values.FundsMonth,
        IdFormAction: 24,
        AnnualSalesDollar:
          values.AnnualSalesDollar === '' ? null : values.AnnualSalesDollar,
        IdCurrencyAnnualSales:
          values.IdCurrencyAnnualSales === ''
            ? null
            : values.IdCurrencyAnnualSales,
      }

      const response = await saveElegibilityForm({
        ...EligibilityForm,
        ...object,
      })

      if (response.Success) {
        saveValuesToContext(values)
        setLoading(false)
        setLoadingSave(false)

        if (borrador) {
          swal({
            title: 'Formulario Guardado',
            icon: 'success',
            button: 'Entendido',
          })
          if (exit) {
            history.push('/')
            setEligibilityForm([])
          }
        } else {
          next()
        }
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      setLoadingSave(false)
      console.log(error.message)
    }
  }

  const saveValuesToContext = () => {
    setEligibilityForm({
      ...EligibilityForm,
      ProblemAnalysis: formik.values.ProblemAnalysis,
      ProposedSolution: formik.values.ProposedSolution,
      ObjectivesActivities: formik.values.ObjectivesActivities,
      ProposedStrategy: formik.values.ProposedStrategy,
      IdCurrencyBudget: formik.values.IdCurrencyBudget,
      IdAnnualSalesProject: formik.values.IdAnnualSalesProject,
      AnnualSales: formik.values.AnnualSales,
      FundsMonth: formik.values.FundsMonth,
      WomenNeeds: formik.values.WomenNeeds,
      AnnualSalesDollar: formik.values.AnnualSalesDollar,
      IdCurrencyAnnualSales: formik.values.IdCurrencyAnnualSales,
    })
  }

  // Función para obtener la moneda por pais
  const getListCurrencyByCountry = async () => {
    try {
      const responseCurrencyByCountry = await getCurrencyByCountry(
        EligibilityForm.IdCountryCredit,
      )

      setCurrencyType(responseCurrencyByCountry.Data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (currencyType.length === 0) getListCurrencyByCountry()
  }, [EligibilityForm.IdCountryCredit])

  const SelectCurrencyUser = (number) => {
    setIdCurrencyUser(number)

    switch (number) {
      case 1:
        setCurrencyCode('HNL')
        break
      case 2:
        setCurrencyCode('NIC')
        break
      case 3:
        setCurrencyCode('DOM')
        break
      case 4:
        setCurrencyCode('CRC')
        break
      case 5:
        setCurrencyCode('GTQ')
        break
      case 6:
        setCurrencyCode('DOP')
        break
    }
  }

  // Funcion para el cambio de la moneda
  const handleCurrency = async () => {
    let currency
    switch (EligibilityForm.IdCurrencyUser) {
      case 1:
        currency = 'HNL'
        break
      case 2:
        currency = 'NIC'
        break
      case 3:
        currency = 'DOM'
        break
      case 4:
        currency = 'CRC'
        break
      case 5:
        currency = 'GTQ'
        break
      case 6:
        currency = 'DOP'
        break
    }
    const dataCurrency = {
      SourceCurrencyCode: currency,
      TargetCurrencyCode: 'USD',
      OriginalAmount: formik.values.AnnualSales,
    }

    if (EligibilityForm.IdCurrencyUser === 3) {
      setAnnualSalesDollar(formik.values.AnnualSales)
      formik.setFieldValue('AnnualSalesDollar', formik.values.AnnualSales)
    } else {
      try {
        const response = await getCurrency(dataCurrency)
        if (response.error !== null)
          setAnnualSalesDollar(
            response.result
              .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
              .currencyExchange.resultingAmount,
          )
        formik.setFieldValue(
          'AnnualSalesDollar',
          response.result
            .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
            .currencyExchange.resultingAmount,
        )
      } catch (error) {
        console.log(error)
      }
    }
  }

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 4 })
    goToStep(4)
  }

  return (
    <>
      {EligibilityForm.IdCurrencyUser === null ||
      EligibilityForm.IdCurrencyUser === '' ||
      EligibilityForm.IdCurrencyUser === undefined ? (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      ) : (
        <Box>
          {/* Comienzo borrador */}
          <Grid
            container
            md={12}
            sm={12}
            spacing={1}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Grid item>
              <div
                data-tip
                data-for="exitPop"
                onClick={() => cancelForm()}
                style={{
                  backgroundColor: 'red',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
                  <span>Regresar</span>
                </ReactTooltip>
              </div>
            </Grid>
            <Grid item>
              <div
                data-tip
                data-for="savePop"
                onClick={() => saveForm(formik.values, true)}
                style={{
                  // backgroundColor: !loadingSave ? '#5cb85c' : 'gray',
                  backgroundColor: '#5cb85c',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <SaveIcon />
              </div>
              <ReactTooltip
                id="savePop"
                effect="solid"
                backgroundColor="#5cb85c"
              >
                <span>Guardar Borrador</span>
              </ReactTooltip>
            </Grid>
          </Grid>
          <br></br>
          {/* Fin borrador */}
          <form id="evaluation-data-form" onSubmit={formik.handleSubmit}>
            <Grid item xs={12} sm={12} md={12}>
              <h1 className="h1text">INFORMACIÓN DEL SUBPROYECTO</h1>
              <br />
            </Grid>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={
                  formik.errors.ProblemAnalysis ||
                  formik.errors.ProposedSolution ||
                  formik.errors.ObjectivesActivities ||
                  formik.errors.ProposedStrategy
                    ? { border: '2px solid red' }
                    : {}
                }
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  5.1. Descripción del subproyecto
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Describa el subproyecto propuesto, incluyendo:
                  </label>
                </Grid>

                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      1. Análisis de problemas
                    </label>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, diagonal, comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <textarea
                        placeholder="Análisis de problema"
                        customInput={TextField}
                        onChange={(e) => {
                          if (
                            e.target.value.match(
                              /[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                            ) ||
                            e.target.value === ''
                          ) {
                            setErrorAnalisis(false)
                            formik.setFieldValue(
                              'ProblemAnalysis',
                              e.target.value,
                            )
                          } else {
                            setErrorAnalisis(true)
                          }
                        }}
                        value={formik.values.ProblemAnalysis}
                        maxLength={1500}
                      ></textarea>
                      {errorAnalisis ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          Caracteres especiales no aceptados
                        </div>
                      ) : null}
                      {formik.errors.ProblemAnalysis ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.ProblemAnalysis}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      2. Análisis de alternativas de solución (análisis de
                      costo-beneficio, etc.), solución propuesta y
                      justificación.
                    </label>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, diagonal, comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <textarea
                        id="fullName"
                        placeholder="Análisis de alternativas de solución"
                        variant="outlined"
                        onChange={(e) => {
                          if (
                            e.target.value.match(
                              /[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                            ) ||
                            e.target.value === ''
                          ) {
                            setErrorAlternativas(false)
                            formik.setFieldValue(
                              'ProposedSolution',
                              e.target.value,
                            )
                          } else {
                            setErrorAlternativas(true)
                          }
                        }}
                        value={formik.values.ProposedSolution}
                        maxLength={1500}
                      ></textarea>
                      {errorAlternativas ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          Caracteres especiales no aceptados
                        </div>
                      ) : null}
                      {formik.errors.ProposedSolution ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.ProposedSolution}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={6} md={6}>
                    <label className="responsiveLabel">
                      3. Objetivo y Actividades
                    </label>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, diagonal, comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <textarea
                        id="fullName"
                        placeholder="Objetivo y Actividades"
                        // error={formik.errors.userFullName}
                        variant="outlined"
                        onChange={(e) => {
                          if (
                            e.target.value.match(
                              /[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                            ) ||
                            e.target.value === ''
                          ) {
                            setErrorObjetivos(false)
                            formik.setFieldValue(
                              'ObjectivesActivities',
                              e.target.value,
                            )
                          } else {
                            setErrorObjetivos(true)
                          }
                        }}
                        value={formik.values.ObjectivesActivities}
                        maxLength={1500}
                      ></textarea>
                      {errorObjetivos ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          Caracteres especiales no aceptados
                        </div>
                      ) : null}
                      {formik.errors.ObjectivesActivities ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.ObjectivesActivities}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={1} className="input__container">
                  <Grid item>
                    <label className="responsiveLabel">
                      4. Narrativa sobre cómo la estrategia de adaptación
                      propuesta y las medidas de adaptación, contribuyen a
                      abordar las necesidades de adaptación y las
                      vulnerabilidades a los impactos del cambio climático y a
                      la variabilidad climática, identificadas.
                    </label>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, diagonal, comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <textarea
                        id="fullName"
                        placeholder="Narrativa sobre la estrategia de adaptación
                    "
                        variant="outlined"
                        onChange={(e) => {
                          if (
                            e.target.value.match(
                              /[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                            ) ||
                            e.target.value === ''
                          ) {
                            setErrorNarrativa(false)
                            formik.setFieldValue(
                              'ProposedStrategy',
                              e.target.value,
                            )
                          } else {
                            setErrorNarrativa(true)
                          }
                        }}
                        value={formik.values.ProposedStrategy}
                        maxLength={1500}
                      ></textarea>
                      {errorNarrativa ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          Caracteres especiales no aceptados
                        </div>
                      ) : null}
                      {formik.errors.ProposedStrategy ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.ProposedStrategy}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={
                  formik.errors.validTable52 ? { border: '2px solid red' } : {}
                }
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  5.2. Medidas de adaptación al cambio climático
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Seleccione la medida de adaptación a implementar por la
                      MIPYME y el área de tierra que se espera mejorar con dicha
                      medida.
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Table52
                      idElegibilityForm={idElegibilityForm}
                      formik={formik}
                    ></Table52>
                    {formik.errors.validTable52 ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.validTable52}
                      </div>
                    ) : null}
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}></Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
                sx={
                  formik.errors.FundsMonth || formik.errors.validateGant
                    ? { border: '2px solid red' }
                    : {}
                }
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  5.3. Cronograma para implementación de presupuesto{' '}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      1. Período estimado de implementación del proyecto.
                    </label>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <FormControl style={{ width: '100%' }}>
                      <Stack component="form" noValidate spacing={3}>
                        <TextField
                          id="date"
                          label="Desde"
                          type="date"
                          variant="outlined"
                          sx={{ width: 220 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={Moment(EligibilityForm.ImplementationDateStart)
                            .format('YYYY-MM-DD')
                            .toString()}
                          disabled
                        />
                      </Stack>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <FormControl style={{ width: '100%' }}>
                      <Stack component="form" noValidate spacing={3}>
                        <TextField
                          id="date"
                          label="Hasta"
                          type="date"
                          variant="outlined"
                          sx={{ width: 220 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={Moment(EligibilityForm.ImplementationDateEnd)
                            .format('YYYY-MM-DD')
                            .toString()}
                          disabled
                        />
                      </Stack>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      2. Marque en el cronograma los meses en que se estima se
                      implementará el proyecto de acuerdo a cada actividad
                      principal.
                    </label>
                    <br></br>
                    <br></br>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <GantChartExtreme
                      formik={formik.setFieldValue}
                      ImplementationDateStart={
                        EligibilityForm.ImplementationDateStart
                      }
                      ImplementationDateEnd={
                        EligibilityForm.ImplementationDateEnd
                      }
                    ></GantChartExtreme>
                    {formik.errors.validateGant ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.validateGant}
                      </div>
                    ) : null}
                  </Grid>
                </Grid>

                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      3. Indique si es necesario recibir los fondos en un mes
                      específico, para poder implementar las inversiones
                      solicitadas de manera oportuna.
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                  </Grid>

                  <Grid item xs={6} sm={6} md={6}>
                    <FormControl style={{ width: '100%' }}>
                      <Stack component="form" noValidate spacing={3}>
                        <TextField
                          id="date"
                          label="Período"
                          type="date"
                          variant="outlined"
                          sx={{ width: 220 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            min: EligibilityForm.ImplementationDateStart,
                            max: EligibilityForm.ImplementationDateEnd,
                          }}
                          onChange={(e) => {
                            formik.setFieldValue('FundsMonth', e.target.value)
                          }}
                          value={formik.values.FundsMonth}
                        />
                      </Stack>
                      {formik.errors.FundsMonth ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.FundsMonth}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                sx={
                  formik.errors.TotalSubProjectBudgetValidation ||
                  formik.errors.RequiredAmountValidation
                    ? { border: '2px solid red' }
                    : {}
                }
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  5.4. Presupuesto
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={4} sm={4} md={4}>
                    <label>Moneda</label>
                    <FormControl fullWidth>
                      <Select
                        id="currencyBudget"
                        name="currencyBudget"
                        value={EligibilityForm.IdCurrencyUser}
                        onChange={(e) => {
                          setCurrencyBudget(e.target.value)
                          formik.setFieldValue(
                            'IdCurrencyBudget',
                            e.target.value,
                          )
                        }}
                        variant="outlined"
                        disabled
                      >
                        <MenuItem value={''} disabled>
                          Seleccione una opción
                        </MenuItem>

                        {currencyType &&
                          currencyType.map((item, key) => (
                            <MenuItem key={key} value={item.IdCurrency}>
                              {item.Description}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4} sm={4} md={4}>
                    <label> Presupuesto total del proyecto</label>
                    <FormControl fullWidth>
                      <NumberFormat
                        id="RequiredAmount"
                        name="RequiredAmount"
                        customInput={TextField}
                        thousandSeparator={true}
                        value={EligibilityForm.TotalSubProjectBudget}
                        autoComplete="off"
                        disabled
                        allowNegative={false}
                        variant="outlined"
                        isNumericString={true}
                        inputProps={{ maxLength: 13 }}
                        fixedDecimalScale
                        decimalScale={2}
                        className="multilineTextField"
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={4} sm={4} md={4}>
                    <label>Monto total del préstamo solicitado</label>
                    <FormControl fullWidth>
                      <NumberFormat
                        id="RequiredAmount"
                        name="RequiredAmount"
                        customInput={TextField}
                        thousandSeparator={true}
                        value={
                          formik.values.IdCurrencyBudget !== 3
                            ? EligibilityForm.RequiredAmountSourceCurrency
                            : EligibilityForm.RequiredAmount
                        }
                        autoComplete="off"
                        disabled
                        allowNegative={false}
                        variant="outlined"
                        isNumericString={true}
                        inputProps={{ maxLength: 13 }}
                        fixedDecimalScale
                        decimalScale={2}
                        className="multilineTextField"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <Table54
                      idElegibilityForm={idElegibilityForm}
                      formik={formik}
                    ></Table54>
                    {formik.errors.TotalSubProjectBudgetValidation ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.TotalSubProjectBudgetValidation}
                      </div>
                    ) : null}
                    {formik.errors.RequiredAmountValidation ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.RequiredAmountValidation}
                      </div>
                    ) : null}
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                sx={
                  formik.errors.IdAnnualSalesProject ||
                  formik.errors.AnnualSales
                    ? { border: '2px solid red' }
                    : {}
                }
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  5.5. Ventas anuales
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Seleccione la opción que corresponde a sus ventas anuales:
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        onChange={(e) => {
                          formik.setFieldValue(
                            'IdAnnualSalesProject',
                            e.target.value,
                          )
                        }}
                        value={formik.values.IdAnnualSalesProject}
                      >
                        <FormControlLabel
                          value="PE"
                          control={<Radio />}
                          label="Proyectos existentes"
                        />
                        <FormControlLabel
                          value="PA"
                          control={<Radio />}
                          label="Proyectos o actividades nuevas"
                        />
                      </RadioGroup>
                      {formik.errors.IdAnnualSalesProject ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.IdAnnualSalesProject}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={1} className="input__container">
                  <Grid item xs={4} sm={4} md={4}>
                    <FormControl style={{ width: '100%' }}>
                      <label>5.5. Ventas anuales</label>
                      <NumberFormat
                        id="fullName"
                        allowLeadingZeros={false}
                        allowNegative={false}
                        decimalScale={2}
                        thousandSeparator={true}
                        customInput={TextField}
                        style={{ width: '100%' }}
                        error={formik.errors.AnnualSales}
                        variant="outlined"
                        value={formik.values.AnnualSales}
                        onChange={(e) => {
                          let inputValue = e.target.value.replaceAll(',', '')

                          // Remove non-numeric characters
                          // Limit the input length to 18 characters

                          if (inputValue.length > 12) {
                            inputValue = inputValue.slice(0, 12)
                          }

                          inputValue = Number(inputValue)

                          formik.setFieldValue('AnnualSales', inputValue)
                        }}
                        inputProps={{ maxLength: 18 }}
                        onBlur={handleCurrency}
                        fixedDecimalScale
                      />
                      {formik.errors.AnnualSales ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.AnnualSales}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4}>
                    <label>Moneda</label>
                    <FormControl fullWidth>
                      <Select
                        id="idCurrency"
                        variant="outlined"
                        error={formik.errors.idSector}
                        onChange={(e) => {
                          setIdCurrencyUser(e.target.value)
                          SelectCurrencyUser(e.target.value)
                          formik.setFieldValue(
                            'IdCurrencyAnnualSales',
                            e.target.value,
                          )
                        }}
                        disabled
                        value={EligibilityForm.IdCurrencyUser}
                        onBlur={handleCurrency}
                      >
                        <MenuItem value={''}>Seleccione una opción</MenuItem>

                        {currencyType &&
                          currencyType.map((item, key) => (
                            <MenuItem key={key} value={item.IdCurrency}>
                              {item.Description}
                            </MenuItem>
                          ))}
                      </Select>
                      {formik.errors.idSector ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.idSector}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                  {EligibilityForm.IdCurrencyUser === 3 ||
                  EligibilityForm.IdCurrencyUser === '' ? (
                    ''
                  ) : (
                    <Grid item xs={4} sm={4} md={4}>
                      <FormControl style={{ width: '100%' }}>
                        <label>Ventas Anuales (USD)</label>
                        <TextField
                          id="fullName"
                          style={{ width: '100%' }}
                          disabled
                          value={formik.values.AnnualSalesDollar}
                          variant="outlined"
                          prefix="$"
                          allowNegative={false}
                          error={formik.errors.AnnualSalesDollar}
                          isNumericString={true}
                          inputProps={{ maxLength: 18 }}
                          fixedDecimalScale
                          decimalScale={2}
                          thousandSeparator={true}
                          customInput={TextField}
                        />
                        {formik.errors.userFullName ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.userFullName}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  )}
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                sx={formik.errors.WomenNeeds ? { border: '2px solid red' } : {}}
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  5.6. Estrategia de género
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Proporcione información sobre cómo el subproyecto se
                      asegurará de incluir las necesidades de las mujeres, y
                      cómo garantizará que los beneficios generados sean
                      igualmente accesibles para hombres y mujeres.
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      1. ¿Cuáles son las necesidades de las mujeres dentro de la
                      MIPYME?
                    </label>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, diagonal, comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <textarea
                        placeholder="Necesidades de las mujeres dentro de la MIPYME"
                        // error={formik.errors.problemName}
                        value={formik.values.problemName}
                        onChange={(e) => {
                          if (
                            e.target.value.match(
                              /[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                            ) ||
                            e.target.value === ''
                          ) {
                            setErrorEstrategia(false)
                            formik.setFieldValue('WomenNeeds', e.target.value)
                          } else {
                            setErrorEstrategia(true)
                          }
                        }}
                        maxLength={2000}
                      ></textarea>
                      {errorEstrategia ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          Caracteres especiales no aceptados
                        </div>
                      ) : null}
                      {formik.errors.WomenNeeds ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.WomenNeeds}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Grid container spacing={1}>
              <Grid container spacing={1} className="button__container">
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  style={{ textAlign: 'left' }}
                  className="continerButtonNav"
                >
                  <Button
                    onClick={() => previous()}
                    variant="contained"
                    className="button__wizard button__previous"
                    // disabled={loading}
                  >
                    Anterior
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  style={{ textAlign: 'right' }}
                  className="continerButtonNav"
                >
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      style={{ textAlign: 'right' }}
                    >
                      <LoadingButton
                        loading={loadingSave}
                        type="button"
                        onClick={() => validateFormStatus()}
                        className="button__wizard button__next"
                        variant="outlined"
                      >
                        Siguiente
                      </LoadingButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Box>
      )}
    </>
  )
}

export default ElegibilidadSec5
